import gql from "graphql-tag";
const getChargebeeSession = gql(` 
query  getChargebeeSession($params: AWSJSON!) {
  getChargebeeSession(params: $params) {
    object
    status
    token
    access_url
    created_at
    customer_id
    expires_at
    id
    linked_customer
  }
}
`)
export default getChargebeeSession
